import { inject, Injectable } from '@angular/core';
import { baseUri } from '../constants/uri.constants';
import { WaterCompositeDto } from '@app/services/water-composite/types/water-composite-dto';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StringUtils } from '@core/utils';

@Injectable({
    providedIn: 'root',
})
export class WaterCompositeService {
    private readonly httpClient = inject(HttpClient);

    public get(transactionId: string): Observable<WaterCompositeDto> {
        return this.httpClient.get<WaterCompositeDto>(StringUtils.parseUri(baseUri, { transactionId }));
    }
}
